import type { KpiColumn, SectionId } from './types';

export const SECTION_IDS: readonly SectionId[] = ['production', 'fuels', 'mix', 'pumps', 'storage'];

export const TITLES: Record<SectionId, string> = {
    production: 'Production et contrats de combustibles',
    fuels: 'Contraintes sur les contrats de combustible',
    mix: 'Contraintes de mix énergétique',
    pumps: 'Pompes de distribution en site de production',
    storage: "Stockages d'eau thermique",
};

export const COLUMNS: Record<SectionId, KpiColumn[]> = {
    production: [
        { key: 'site', label: 'Site de production', flex: 1.2, link: true },
        { key: 'boiler', label: 'Chaudière', link: true },
        { key: 'priority', label: 'Priorité', editable: true },
        { key: 'contract', label: 'Contrats de combustible', flex: 1.2, link: true },
        { key: 'price', label: 'Prix par défaut' },
        { key: 'min', label: 'Production minimale (MW)', flex: 1.2, editable: true },
        { key: 'max', label: 'Production maximale (MW)', flex: 1.2, editable: true },
        { key: 'efficiencyMin', label: 'Rendement à Pmin', flex: 1.2 },
        { key: 'efficiencyMax', label: 'Rendement à Pmax', flex: 1.2 },
        { key: 'rampUp', label: 'Max montée en puissance (MW/h)', flex: 1.2, editable: true },
        { key: 'rampDown', label: 'Max descente en puissance (MW/h)', flex: 1.2, editable: true },
    ],
    fuels: [
        { key: 'contract', label: 'Contrats de combustible', link: true },
        { key: 'calorific', label: 'Valeur calorifique [J/quantité]', editable: true },
        { key: 'yearStart', label: "Démarrage de l'année comb" },
        { key: 'dayStart', label: 'Démarrage de la journée comb' },
        { key: 'hourMin', label: 'Min horaire', editable: true },
        { key: 'hourMax', label: 'Max horaire', editable: true },
        { key: 'dayMin', label: 'Min journalier', editable: true },
        { key: 'dayMax', label: 'Max journalier', editable: true },
        { key: 'yearMin', label: 'Min annuel', editable: true },
        { key: 'yearMax', label: 'Max annuel', editable: true },
        { key: 'description', label: 'Description', editable: true },
    ],
    mix: [
        { key: 'name', label: 'Contraintes de mix énergétique', link: true },
        { key: 'startDay', label: 'Jour de la date de début' },
        { key: 'startMonth', label: 'Mois de la date de début' },
        { key: 'endDay', label: 'Jour de la date de fin' },
        { key: 'endMonth', label: 'Mois de la date de fin' },
        { key: 'min', label: 'Borne inférieure' },
        { key: 'max', label: 'Borne supérieure' },
        { key: 'contract', label: 'Contrats de combustible', link: true },
        { key: 'ratio', label: 'Ratio' },
    ],
    pumps: [
        { key: 'site', label: 'Site de production', flex: 1.2, link: true },
        { key: 'group', label: 'Groupe de pompes', link: true },
        { key: 'pump', label: 'Pompe', link: true },
        { key: 'type', label: 'Type' },
        { key: 'speedMin', label: 'Vitesse de rotation minimale (tr/min)', editable: true },
        { key: 'speedMax', label: 'Vitesse de rotation nominale (tr/min)', editable: true },
        { key: 'flow', label: 'Débit volumique (m³/h)' },
        { key: 'pressure', label: 'Delta de pression (bar)' },
        { key: 'efficiency', label: 'Rendement' },
        { key: 'contract', label: "Contrat d'électricité", link: true },
        { key: 'price', label: 'Prix par défaut' },
    ],
    storage: [
        { key: 'name', label: "Stockages d'eau thermique", link: true },
        { key: 'volume', label: 'Débit volumique (m³/h)' },
        { key: 'loadMax', label: 'Débit maximal de charge (m³/h)' },
        { key: 'unloadMax', label: 'Débit maximal de décharge (m³/h)' },
        { key: 'contract', label: "Contrat d'électricité", link: true },
        { key: 'price', label: 'Prix par défaut' },
    ],
};
